import slug from "slug";
export const Slug = slug;
